import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Carlos Mendes",
    role: "Empresário",
    content: "Excelente atendimento! Meu iPhone estava com a tela quebrada e foi reparado em poucas horas. Qualidade impecável e preço justo.",
    rating: 5,
    device: "iPhone 14 Pro"
  },
  {
    name: "Ana Paula Silva",
    role: "Advogada",
    content: "Levei meu notebook que não ligava mais e a equipe identificou o problema rapidamente. Serviço profissional e com garantia.",
    rating: 5,
    device: "MacBook Pro"
  },
  {
    name: "Roberto Almeida",
    role: "Atleta",
    content: "Meu Garmin Fenix voltou a funcionar perfeitamente! São especialistas mesmo em relógios esportivos. Super recomendo.",
    rating: 5,
    device: "Garmin Fenix 7"
  },
  {
    name: "Mariana Costa",
    role: "Designer",
    content: "Fizeram o upgrade do SSD do meu notebook e ficou muito mais rápido. Atendimento transparente, explicaram tudo direitinho.",
    rating: 5,
    device: "Dell XPS 15"
  },
  {
    name: "Felipe Santos",
    role: "Médico",
    content: "Precisei de um reparo urgente no meu Samsung e eles resolveram no mesmo dia. Profissionalismo nota 10!",
    rating: 5,
    device: "Samsung S23 Ultra"
  },
  {
    name: "Juliana Lima",
    role: "Empreendedora",
    content: "Além do reparo do celular, fizeram um site incrível para minha empresa. Parceiro completo em tecnologia!",
    rating: 5,
    device: "iPhone + Website"
  },
];

export const Testimonials = () => {
  return (
    <section id="depoimentos" className="section-darker py-24 md:py-32 grid-bg" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-[#00F0FF] text-sm font-mono uppercase tracking-widest">
            [ Depoimentos ]
          </span>
          <h2 className="font-orbitron text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            O Que Nossos <span className="text-[#00F0FF]">Clientes</span> Dizem
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto font-space">
            Mais de 5000 clientes satisfeitos confiam na Vaz Tech Solutions para cuidar de seus dispositivos.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="testimonial-card"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <Quote size={24} className="text-[#00F0FF]/30 mb-4" />

              {/* Content */}
              <p className="text-[#94A3B8] font-space text-sm leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={14} className="text-[#FFD600] fill-[#FFD600]" />
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-rajdhani font-bold text-white">{testimonial.name}</div>
                  <div className="text-xs text-[#94A3B8]">{testimonial.role}</div>
                </div>
                <div className="text-xs font-mono text-[#00F0FF]/70 bg-[#00F0FF]/5 px-2 py-1 border border-[#00F0FF]/20">
                  {testimonial.device}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <p className="text-[#94A3B8] text-sm font-space mb-6">Marcas que reparamos:</p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-60">
            {['Apple', 'Samsung', 'Xiaomi', 'Motorola', 'Garmin', 'Dell', 'HP', 'Lenovo'].map((brand, index) => (
              <span key={index} className="font-rajdhani text-lg text-white/50 hover:text-[#00F0FF] transition-colors cursor-default">
                {brand}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
